import React from 'react';
import type { PrismicRichContent } from '../../../../../types';
import RichText from '../rich-text';

import * as S from './styles';

type Props = {
  data: PrismicRichContent[];
};

const Text = ({ data }: Props) => {
  return (
    <S.Text>
      <RichText data={data} />
    </S.Text>
  );
};

export default Text;
